module.exports = function ($, M) {
  'use strict';

  M.learning_performance = {};

  var performance = M.learning_performance,
    learningChart = null,
    testingChart = null;

  $.extend(true, M.learning_performance, {
    initTestingGraph: function () {
      performance.initTestingDropdowns();
      performance.setTestingLazyLoading();
      performance.setImageGrab();
    },
    initTestingDropdowns: function () {
      $('.filters')
        .on('click', '.filter .dropdown-menu a', function (e) {
          e.preventDefault();
          var $this = $(this),
            $filter = $this.closest('.filter'),
            $btn1 = $('.btn1', $filter),
            filter = $this.data('filter'),
            params = {
              filter: filter,
            };
          if ($this.data('id')) params['id'] = $this.data('id');

          $btn1.toggleClass('bgGreen');
          $this
            .parent('li')
            .addClass('active')
            .siblings()
            .removeClass('active');
          $btn1.text($(this).text());

          performance.loadTestingData(
            params,
            performance.updateTestingChart,
          );
        })
        .on('click', '.btn1', function (e) {
          e.stopPropagation();
          $(this).siblings('.dropdown-toggle').click();
        });
    },

    setTestingLazyLoading: function () {
      if (performance.isVisible('#lazy-learning-insight')) {
        $(window).unbind('scroll');
        performance.loadTestingData(
          null,
          performance.initialTestingLoadCallback,
        );
      } else {
        $(window).scroll(function () {
          if (performance.isVisible('#lazy-learning-insight')) {
            $(window).unbind('scroll');
            performance.loadTestingData(
              null,
              performance.initialTestingLoadCallback,
            );
          }
        });
      }
    },
    isVisible: function (elem) {
      var winTop = $(window).scrollTop(),
        winBottom = winTop + $(window).height(),
        elemTop = $(elem).offset();
      if (elemTop === null) return false;
      else return elemTop.top <= winBottom;
    },
    setImageGrab: function () {
      if (typeof d3 !== 'undefined') {
        $('#screencapture a').on('click', function (e) {
          e.preventDefault();
        });
        d3.select('#screencapture a').on('click', function (e) {
          var html = d3
              .select('#chart-testing svg')
              .attr('version', 1.1)
              .attr('xmlns', 'http://www.w3.org/2000/svg')
              .node().parentNode.innerHTML,
            re = /<image.*?>[\w|\d|\w]*<\/image>/gi,
            htmlStripped = html.replace(re, ''),
            imgsrc =
              'data:image/svg+xml;base64,' + window.btoa(htmlStripped),
            img = '<img src="' + imgsrc + '" alt="">';

          d3.select('#imageGrab').html(img);
          performance.showModal();
        });
      }
    },
    showModal: function () {
      MEMRISE.modal.content(
        {
          modalId: 'imageForumPost',
          showHeader: true,
          showFooter: false,
          backdrop: true,
          keyboard: true,
          template: 'imageForumPost',
          shadow: false,
          headerText: _t(
            'Start a new thread on forum with your testing behavior image included',
          ),
          seeThru: false,
          removeOnHidden: true,
        },
        function () {
          performance.initPostForm();
        },
      );
    },
    initPostForm: function () {
      $('#imageGrab img')
        .clone()
        .appendTo($('.modalContent .postedImage'));
    },
    updateTestingChart: function (filteredData) {
      testingChart.dataProvider = filteredData.data;
      testingChart.validateData();
    },
    initialTestingLoadCallback: function (data) {
      var chartData = performance.setTestingData(data);
      testingChart = AmCharts.makeChart('chart-testing', {
        type: 'xy',
        theme: 'none',
        pathToImages: 'https://www.amcharts.com/lib/3/images/',
        dataProvider: chartData,
        chartCursor: {},
        legend: {
          useGraphSettings: true,
          equalWidths: false,
          fontSize: 13,
          rollOverGraphAlpha: 0.15,
          switchable: true,
        },
        valueAxes: [
          {
            //x
            title: _t('Time of the day'),
            position: 'bottom',
            autoGridCount: false,
            gridCount: 12,
            maximum: 23,
            minimum: 0,
          },
          {
            // y
            title: _t('Response time in seconds'),
            position: 'left',
            autoGridCount: false,
            gridCount: 10,
            maximum: 20,
          },
        ],
        startDuration: 0.3,
        graphs: [
          {
            // correct
            id: 'correct',
            balloonText: _t(
              'At __tag1__ your __br__ average response __br__ time is __tag2__.',
              {
                tag1: '<b>[[yCorrectBalloon]]</b>',
                br: '<br />',
                tag2: '<b>[[y]]s</b>',
              },
            ),
            bullet: 'bubble',
            lineColor: '#83c53d',
            lineAlpha: 0,
            title: _t('Correct'),
            xField: 'xCorrect',
            yField: 'yCorrect',
            valueField: 'amountCorrect',
            fillAlphas: 0,
            bulletBorderAlpha: 0.2,
            maxBulletSize: 20,
            minBulletSize: 4,
          },
          {
            // nearly correct
            id: 'nearlyCorrect',
            balloonText: _t(
              'At __tag1__ your __br__ average response __br__ time is __tag2__.',
              {
                tag1: '<b>[[yNearlyCorrectBalloon]]</b>',
                br: '<br />',
                tag2: '<b>[[y]]s</b>',
              },
            ),
            bullet: 'bubble',
            lineColor: '#e89c06',
            lineAlpha: 0,
            title: _t('Nearly correct'),
            xField: 'xNearlyCorrect',
            yField: 'yNearlyCorrect',
            valueField: 'amountNearlyCorrect',
            fillAlphas: 0,
            bulletBorderAlpha: 0.2,
            maxBulletSize: 20,
            minBulletSize: 4,
          },
          {
            // incorrect
            id: 'incorrect',
            balloonText: _t(
              'At __tag1__ your __br__ average response __br__ time is __tag2__.',
              {
                tag1: '<b>[[yIncorrectBalloon]]</b>',
                br: '<br />',
                tag2: '<b>[[y]]s</b>',
              },
            ),
            bullet: 'bubble',
            lineColor: '#bb2e25',
            lineAlpha: 0,
            title: _t('Incorrect'),
            xField: 'xIncorrect',
            yField: 'yIncorrect',
            valueField: 'amountIncorrect',
            fillAlphas: 0,
            bulletBorderAlpha: 0.2,
            maxBulletSize: 20,
            minBulletSize: 4,
          },
        ],
        chartScrollbar: {
          backgroundColor: '#15a1ec',
          updateOnReleaseOnly: false,
        },
      });
      $('#chart-testing')
        .css('visibility', 'visible')
        .parent()
        .find('.loading-spinner')
        .hide();
    },
    loadTestingData: function (params, callback) {
      $.ajax({
        type: 'GET',
        url: '/ajax/metrics/fancy_tests_graph/',
        async: true,
        data: params,
        success: function (data) {
          if (typeof callback === 'function') callback(data.data);
        },
      });
    },
    initAttendanceDataGrid: function () {
      $.ajax({
        type: 'GET',
        url: '/ajax/metrics/learning_streak_graph/',
        success: function (data) {
          // Create grid
          var grid = $('#attendance-grid');
          grid.html('');
          new MEMRISE.charts.AttendanceGrid({
            elem: grid,
            data: data['attendance_data'],
            dateField: 'day',
            countField: 'num_events',
            countName: 'Learning Event',
            firstDate: data['start_day'],
            lastDate: data['today'],
          });

          // Create labels
          var label1 = $('#attendance-grid-label1'),
            label2 = $('#attendance-grid-label2'),
            label3 = $('#attendance-grid-label3'),
            days,
            val;

          val = data['total_days_learned'];
          days = val == 1 ? _t('day') : _t('days');
          label1
            .show()
            .find('.body')
            .html(
              '<span class="large">' +
                val +
                '</span><span class="day">' +
                days +
                '</span>',
            );

          val = data['longest_streak'];
          days = val == 1 ? _t('day') : _t('days');
          label2
            .show()
            .find('.body')
            .html(
              '<span class="large">' +
                val +
                '</span><span class="day">' +
                days +
                '</span>',
            );

          val = data['current_streak'];
          days = val == 1 ? _t('day') : _t('days');
          label3
            .show()
            .find('.body')
            .html(
              '<span class="large">' +
                val +
                '</span><span class="day">' +
                days +
                '</span>',
            );
        },
      });
    },
    initMostLearntCoursesChart: function (courseData) {
      var chart = AmCharts.makeChart('chart-coursetime', {
        type: 'pie',
        theme: 'none',
        minRadius: 100,
        dataProvider: courseData,
        valueField: 'time',
        titleField: 'course',
        labelsEnabled: false,
        colors: [
          '#15a1ec',
          '#aa5f86',
          '#e89c06',
          '#83c53d',
          '#ff1605',
          '#aa5f10',
        ],
        pieX: '20%',
        pieY: '44%',
        legend: {
          position: 'absolute',
          width: 300,
          top: 10,
          right: 120,
          verticalGap: 20,
          markerType: 'square',
          markerSize: 32,
          valueText: '[[none]]',
        },
        balloonText:
          "<span style='font-size:10px'><b>[[course]]</b><br />[[timehms]]</span>",
      });

      $.each(courseData, function (k, v) {
        var url = v.id ? '/course/' + v.id : '/courses/',
          text = _t('Learn');
        $('.whitebox.buttons .btns').append(
          "<a href='" +
            url +
            "' class='btn btn-success btn-green'>" +
            text +
            '</a>',
        );
      });
    },
    setTestingData: function (data) {
      var correct = [],
        nearly = [],
        incorrect = [],
        temp;

      for (var i = 0; i < data.length; i++) {
        if (data[i].correct_resp_time !== 0) {
          correct.push({
            yCorrect: data[i].correct_resp_time,
            xCorrect: data[i].x_axis,
            yCorrectBalloon: data[i].time,
            amountCorrect: data[i].correct,
          });
        }
        if (data[i].partially_correct_resp_time !== 0) {
          nearly.push({
            yNearlyCorrect: data[i].partially_correct_resp_time,
            xNearlyCorrect: data[i].x_axis,
            yNearlyCorrectBalloon: data[i].time,
            amountNearlyCorrect: data[i].partially_correct,
          });
        }
        if (data[i].incorrect_resp_time !== 0) {
          incorrect.push({
            yIncorrect: data[i].incorrect_resp_time,
            xIncorrect: data[i].x_axis,
            yIncorrectBalloon: data[i].time,
            amountIncorrect: data[i].incorrect,
          });
        }
      }
      temp = correct.concat(nearly);
      return temp.concat(incorrect);
    },
  });
};
